<template>
    <div class="d-flex flex-column flex-md-row p-y-small-16 p-r-16 p-l-0 p-l-small-16 align-items-start align-items-md-center" style="background-color: white; border-radius: 16px; border: 1px solid #FAFAFA;">
        <img :src="$image('stories/Image-3.png')" alt="" class="m-r-32 m-r-small-0 sm:mb-4 aspect" style="border-radius: 8px;" width="160" height="160">
        <div class="d-flex flex-column">
            <span class="font s-f-20 leading-7 l-t-s-75 font-extrabold">Streamlined Process</span>
            <span class="font text-base leading-6 font-normal">From recruitment to fulfillment, data collection, and analysis, everything is fully automated and under one roof. </span>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.aspect{
    width: 104px;
    height: 104px;
    @media screen and (min-width: 768px){
        width: 160px;
        height: 160px;
    }
}
</style>
